import React, { useRef, useMemo, useState, useEffect, useContext } from "react";

import CustomizableTable from "components/client/CustomizableTable/CustomizableTable";
import { renderColumn } from "utils/helpers";
import FormHOC from "hoc/FilltersForm";
import { useWindowWidth } from "hooks";
import { RtlContext } from "../../../App";


export default FormHOC(({
    data,
    type,
    page,
    count,
    perPage,
    perPageLSKey,
    loading,
    service,
    availableColumns,
    pickedColumns,
    savedTableColumns,
    getItems,
    onSaveColumnsTable,
    extraRows
}) => {

    const tableRef = useRef();
    const rtl = useContext(RtlContext);
    const [columns, onChangeColumns] = useState(pickedColumns);
    const [columnsWereChanged, setColumnsWereChanged] = useState(false);

    useEffect(() => {
        onChangeColumns(pickedColumns);
    }, [pickedColumns]);

    useEffect(() => {
        if (!columns.length && pickedColumns.length) {
            onChangeColumns(pickedColumns);
        }
    }, [pickedColumns]);

    useEffect(() => {
        onChangeColumns(pickedColumns);
    }, [pickedColumns]);

    const windowWidth = useWindowWidth();

    const selectedColumns = useMemo(() => {
        const pickedSet = new Set(pickedColumns.map(c => c.id));
        const base = columns.filter(c => pickedSet.has(c.id));

        const savedSet = Array.isArray(savedTableColumns) ? new Set(savedTableColumns) : null;
        const allowed = savedSet ? base.filter(c => savedSet.has(c.id)) : base;


        if (!data || data.length === 0) return allowed;

        const hasAnyValue = (key) => {
            for (const row of data) {
                if (Object.prototype.hasOwnProperty.call(row ?? {}, key)) return true;
            }

            return false;
        };

        const visible = allowed.filter(col => hasAnyValue(col.dataKey));

        return visible.length > 0 ? visible : allowed;
    }, [columns, pickedColumns, savedTableColumns, data]);

    const renderedColumns = selectedColumns.map(renderColumn);

    return (
        <CustomizableTable
            ref={tableRef}
            {...{
                rtl,
                data,
                count,
                page,
                perPage,
                loading,
                getItems,
                renderedColumns,
                onSaveColumnsTable,
                savedTableColumns,
                extraRows
            }}
            onChangeColumns={(newColumns) => {
                setColumnsWereChanged(true);
                onChangeColumns(newColumns);
            }}
            pickedColumns={availableColumns || pickedColumns}
            isChangedColumns={true}
            isPaginated={true}
            perPageLSKey={perPageLSKey}
            hidePages={count < perPage}
            hidePerPage={true}
            isMobile={windowWidth < 768 ? true : false}
            rowClassName={rowData => {
                if (rowData && rowData.id === "summaries") {
                    return "summaries";
                }

                return "";
            }}
        />
    );
});
